import { render, staticRenderFns } from "./OrderHistory.vue?vue&type=template&id=685a177a"
import script from "./OrderHistory.vue?vue&type=script&lang=js"
export * from "./OrderHistory.vue?vue&type=script&lang=js"
import style0 from "./OrderHistory.vue?vue&type=style&index=0&id=685a177a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports